import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import PolicyListPage from './pages/PolicyListPage';
import PolicyExceptionsPage from './pages/PolicyExceptionsPage';

export const policyModule: ModuleDefinition = {
  routes: [
    { path: 'corporate/policy', element: <PolicyListPage /> },
    { path: 'corporate/policy/:policyId/exceptions', element: <PolicyExceptionsPage /> },
  ],
  menuItems: [
    {
      label: 'Kurumsal: Politikalar',
      path: 'corporate/policy',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
